export function formatReplaceUnderscores(text: string) {
  return text.replace(/[_]/g, " ");
}
